import { useState } from "react";
import QueryModalInput from "views/components/QueryModal/QueryModalInput";
import {
  CustomMetadata,
  CustomMetadataOperators,
  CUSTOM_METADATA_NUMBER_OPERATORS,
  QueryOperator,
} from "types";
import { convertAPIOperator } from "helpers/utility/queryFilterHelpers";
import { CustomNameNumberIcon } from "assets/icons/CustomMetadataIcons";
import { useCustomMetadataModal } from "hooks/useCustomMetadataModal";
import BaseQueryModal from "./BaseQueryModal";
import {useNumberQueryModal} from "hooks/UseQueryModal/useNumberQueryModal";

interface NumberModalProps {
  field: CustomMetadata;
  editQueryId?: string;
}

export default function NumberModal({ editQueryId, field }: NumberModalProps) {
  const { modalRef, oldQuery, handleSubmission, fieldName } =
    useCustomMetadataModal({ field, editQueryId });

  const previousValue = (oldQuery?.custom_metadata?.value as string) || "";

  const queryOperator = oldQuery
    ? (convertAPIOperator(
        oldQuery.custom_metadata.op
      ) as CustomMetadataOperators)
    : null;

  const [selectedOp, setSelectedOp] = useState<CustomMetadataOperators | null>(
    queryOperator
  );
  const [searchText, setSearchText] = useState(previousValue);

  const operatorsWithDefault = [
    { value: null, label: "Choose Type" },
    ...CUSTOM_METADATA_NUMBER_OPERATORS,
  ];

  const { isSubmitDisabled } = useNumberQueryModal({
    inputValue: Number(searchText),
    previousValue: Number(previousValue),
    selectedOperator: selectedOp as QueryOperator,
    initialOperator: queryOperator as QueryOperator,
  });


  const handleSubmit = () => {
    if (isSubmitDisabled || !selectedOp) return;
    handleSubmission(selectedOp, searchText.trim());
  };

  const handleInputChange = (value: string) => {
    setSearchText(value);
  };

  const handleOptionSelection = (operator: CustomMetadataOperators | null) => {
    if (operator === selectedOp) return;
    setSelectedOp(operator);
  };

  const operators = {
    options: operatorsWithDefault,
    selected: selectedOp,
    onSelect: handleOptionSelection,
  };

  return (
    <BaseQueryModal<CustomMetadataOperators | null>
      title={fieldName}
      keepOpenOnLoading
      modalRef={modalRef}
      icon={<CustomNameNumberIcon />}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleSubmit}
      operators={operators}
    >
      <QueryModalInput
        numberOnly
        searchText={searchText}
        placeholder="Number Input"
        onInputChange={handleInputChange}
      />
    </BaseQueryModal>
  );
}
